export const getPackStats = (pack?: PackTemplate) => {
  if (!pack || !pack.costTiers) return {};
  const total = pack.costTiers[pack.costTiers.length - 1].max;
  const remaining = total - pack.inventoryCount;
  const tierIndex = pack.costTiers.findIndex(
    (t) => remaining >= t.min - 1 && remaining <= t.max
  );
  const tier = pack.costTiers[tierIndex];
  if (!tier)
    return {
      remainingTilNext: 0,
      tier: { ethPrice: '0', min: 0, max: 0 },
      tierProgressWidth: '0%',
    };
  const remainingTilNext = tier ? tier.max - remaining : undefined;
  const segmentWidth = 100 / pack.costTiers.length;
  const tierProgress =
    tierIndex * segmentWidth +
    ((remaining - tier.min) / (tier.max - tier.min)) * segmentWidth;
  const tierProgressWidth = `${tierProgress}%`;
  return { remainingTilNext, tier, tierProgressWidth };
};
